import { Col } from '@farol-ds/react'
import classNames from 'classnames'
import { HTMLAttributes } from 'react'

import styles from './appbar-end.module.scss'

export type AppBarEndElement = HTMLDivElement

export type AppBarEndProps = HTMLAttributes<AppBarEndElement>

function AppBarEnd(props: AppBarEndProps) {
  const { children, className, ...rest } = props
  const classes = classNames(styles.root, className)
  return (
    <Col xs={12} md={6} lg={5}>
      <div {...rest} className={classes} data-fds-appbar-end>
        {children}
      </div>
    </Col>
  )
}

export default AppBarEnd
